// frontend/src/components/PublicLayout.js
import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";

const PublicLayout = () => {
  return (
    <>
      <Navbar onMenuClick={() => {}} />
      <Outlet />
    </>
  );
};

export default PublicLayout;
